import { useAxiosCreate } from '@/backend/utils';

const http = useAxiosCreate('api');

export function searchTrips360(q, limit = 10) {
  return http
    .get('statistics/trip360/search', { params: { q, limit } })
    .then(({ data }) => data.rows || []);
}

export function fetchTrip360(key) {
  return http
    .get('statistics/trip360/trip', { params: { key } })
    .then(({ data }) => data.trip);
}

export function patchTrip360(key, payload) {
  return http
    .patch('statistics/trip360/trip', { key, ...payload })
    .then(({ data }) => data);
}

export function fetchTrip360History(key, limit = 500) {
  return http
    .get('statistics/trip360/history', { params: { key, limit } })
    .then(({ data }) => data.events || []);
}
